import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {PTOFacade} from "../../facade/pto.facade";
import {combineLatest, map} from "rxjs";

@Component({
  selector: 'app-project-team-overview-main',
  templateUrl: './project-team-overview-main.component.html',
  styleUrls: ['./project-team-overview-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectTeamOverviewMainComponent implements OnInit {
  readonly vm$ = combineLatest([
    this.projectFacade.projects$,
    this.projectFacade.loading$,
  ]).pipe(
    map(([projects, loading]) => ({
      projects,
      loading,
    })),
  )

  constructor(private projectFacade: PTOFacade) { }

  ngOnInit(): void {
    this.projectFacade.loadProjects({
      projectUuid: '',
      filters: {
        sort: 'ASC',
        projects: [],
        projectTypeUuid: '',
        categoryUuid: ''
      },
      params: {
        page: 1,
        limit: 5,
      }
    });
  }

}
